import { ElementRef, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormTrackerService {
  private static formGroups = new Map<ElementRef, FormGroup>();

  public registerForm(ref: ElementRef, formGroup: FormGroup): void {
    FormTrackerService.formGroups.set(ref, formGroup);
  }

  public getDirtyForms(): FormGroup[] {
    return [...FormTrackerService.formGroups.values()].filter(form => form.dirty === true);
  }

  public clearFormList(): void {
    return FormTrackerService.formGroups.clear();
  }

  public getTouchedValues(formGroup: FormGroup): Record<string, unknown> {
    const touchedValues: Record<string, unknown> = {};
    for (const key in formGroup.controls) {
      if (formGroup.controls[key].touched) {
        touchedValues[key] = formGroup.controls[key].value;
      }
    }
    return touchedValues;
  }
}
